module.exports = __webpack_public_path__ + "prize.db06bf4.jpg";